import { handleActions } from 'redux-actions';
import { NAMES as GET_VIDEO_CARDS } from 'widget/redux/server/actions/video-cards/get';
import { VIDEO_CARDS_CLEANUP } from 'widget/redux/client/actions/video-cards/cleanup';
import WixSDK from 'shared/utils/wix-sdk';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/dist/video-cards/types';
import i18n from '@wix/wix-vod-shared/dist/src/common/i18n';
import { LIVE_STATUSES } from '@wix/wix-vod-constants/dist/common/live-statuses';

const defaultState = [];

const THUMBNAIL_SIZE = 292;

export default handleActions(
  {
    [GET_VIDEO_CARDS.SUCCESS]: (cards, { payload }) => {
      const data = payload.response;
      return data.map(card => {
        if (card.dateStartLive) {
          const datetime = new Date(card.dateStartLive).toLocaleTimeString([], {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
          });

          card.liveLabel = `${i18n.t(
            'widget.video-cards.live-label',
          )}: ${datetime}`;
        }

        if (
          card.type === VIDEO_CARD_TYPES.VIDEO ||
          card.type === VIDEO_CARD_TYPES.RECENT_VIDEO
        ) {
          if (card.itemType === LIVE_STATUSES.STREAMING) {
            card.buttonLabel = i18n.t('widget.video-cards.watch-live');
          } else {
            card.buttonLabel = i18n.t('widget.video-cards.watch-next');
          }
        }

        if (card.type === VIDEO_CARD_TYPES.CHANNEL) {
          card.buttonLabel = i18n.t('widget.video-cards.watch-more');
        }

        return {
          ...card,
          thumbnailUrl: WixSDK.Utils.Media.getResizedImageUrl(
            card.thumbnailUrl,
            THUMBNAIL_SIZE,
            THUMBNAIL_SIZE,
            {
              lg: 1,
            },
          ),
        };
      });
    },
    [VIDEO_CARDS_CLEANUP]: () => defaultState,
  },

  defaultState,
);
